function getBasenameAndIndex(fullPath: string, pathSep: string) {
  let i = fullPath.length - 1;
  while (i >= 0 && fullPath[i] === pathSep) {
    --i;
  }
  const end = i + 1;
  while (i >= 0  && fullPath[i] !== pathSep) {
    --i;
  }
  const start = i + 1;
  return { result: fullPath.slice(start, end), index: start };
}

export function getBasename(fullPath: string, pathSep: string) {
  return getBasenameAndIndex(fullPath, pathSep).result;
}

export function getDirname(fullPath: string, pathSep: string) {
  let i = fullPath.length - 1;
  while (i >= 0 && fullPath[i] === pathSep) {
    --i;
  }
  while (i >= 0  && fullPath[i] !== pathSep) {
    --i;
  }
  if (i < 0) {
    if (fullPath.startsWith('/')) {
      return '/';
    }
    return '.';
  }
  return fullPath.slice(0, i);
}

export function getBasenameAndIndexWithoutExtension(fullPath: string, pathSep: string) {
  const { result: basename, index } = getBasenameAndIndex(fullPath, pathSep);
  const pos = basename.lastIndexOf('.');
  /*
    The (pos < 1) expression handles both the case of no '.' in file name, and
    the case of the only '.' being a leading dot in a dot-file.
  */
  if (pos < 1) {
    return { result: basename, index } ;
  }

  return { result: basename.slice(0, pos), index };
}

export function getBasenameWithoutExtension(fullPath: string, pathSep: string) {
  return getBasenameAndIndexWithoutExtension(fullPath, pathSep).result;
}

export function getExtname(path: string, pathSep: string) {
  const basename = getBasename(path, pathSep);
  const pos = basename.lastIndexOf('.');
  /*
    The (pos < 1) expression handles both the case of no '.' in file name, and
    the case of the only '.' being a leading dot in a dot-file.
  */
  if (pos < 1) {
    return '';
  }
  return basename.slice(pos);
}
